export default "// removed by extract-text-webpack-plugin"